import React, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Message from "./Message";
const roles =
  localStorage.getItem("user_role") !== null
    ? localStorage.getItem("user_role").split(",")
    : "";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const VendorSettings = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {" "}
      <div className="content-wrapper">
        <Box
          sx={{
            flexGrow: 1,
            bgcolor: "background.paper",
            display: "flex",
            padding: "15px",
            width: "100%",
            overflow: "hidden",
            flexDirection: "column",
          }}
        >
          <Tabs
            orientation="horizontal"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{ borderRight: 1, borderColor: "divider", width: "100%" }}
          >
            <Tab label="Rules" {...a11yProps(0)} />
            {roles.includes("Admin") ? (
              <Tab label="Payment Mode" {...a11yProps(1)} />
            ) : (
              <></>
            )}
            <Tab label="Pickup Slot" {...a11yProps(2)} />
          </Tabs>
          <TabPanel sx={{ width: "85%" }}>
            <h2>
              {value === 0
                ? "Rules"
                : value === 1
                  ? "Payment Mode"
                  : value === 2
                    ? "Pickup Slot"
                    : ""}
            </h2>
            <Message id={value} />
          </TabPanel>
        </Box>
      </div>
    </>
  );
};

export default VendorSettings;
